module.exports = __webpack_public_path__ + "img/1533491926.ddd4ee47.jpg";